const STORAGE_KEY = 'porto-seco-panel-'

function save(data, key, stringfy){
    let save = data
    if(stringfy){
        save = JSON.stringify(save)
    }
    localStorage.setItem(STORAGE_KEY + key, save)
}

function read(key){
    return localStorage.getItem(STORAGE_KEY + key)
}

function remove(key){
    localStorage.removeItem(STORAGE_KEY + key)
}

function getUser(){
   let user = localStorage.getItem(STORAGE_KEY + 'user')
   user = JSON.parse(user)
   return user
}

function updateUser(key, value){
    let user    = localStorage.getItem(STORAGE_KEY + 'user')
    user        = JSON.parse(user)
    user[key]   = value + '?v=' + Math.floor(Math.random() * 9999)
    user        = JSON.stringify(user)
    localStorage.setItem(STORAGE_KEY + 'user', user)
}

function updateUserData(key, value){
    let user    = localStorage.getItem(STORAGE_KEY + 'user')
    user        = JSON.parse(user)
    user[key]   = value
    user        = JSON.stringify(user)
    localStorage.setItem(STORAGE_KEY + 'user', user)
}



export {
    save,
    read,
    remove,
    getUser,
    updateUser,
    updateUserData
}